<template>
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 30px">
              <!--            <el-breadcrumb-item><el-tag size="small" :type="$route.name==='项目信息总览'?'info':'primary'">项目信息总览</el-tag></el-breadcrumb-item>-->
              <el-breadcrumb-item v-for="(item,index) in currentNav">
                <!--              <el-tag size="small" class="routerTag"-->
                <!--                      closable @close="handleClose(item,index)"-->
                <!--                      @click="handleClick(item)" >{{ item }}-->
                <!--              </el-tag>-->

<!--                <el-tag size="small">{{ item }}-->
<!--                </el-tag>-->
                <span style="font-size: 15px">{{ item }}</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
</template>

<script>
export default {
  name: "HeaderBread",
  data(){
    return{
      currentNavList: []
    }
  },
  computed: {

    currentNav() {
      return this.$route.name.split('/')
    }
  },
}
</script>

<style scoped>

</style>
